import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import logo from '../assets/logo.svg';

const Container = styled.div`
  max-width: 1200px;
  margin: 40px auto;
  padding: 20px;
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 40px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

const LogoContainer = styled.div`
  text-align: right;
`;

const Logo = styled.img`
  width: 250px;
  height: auto;
`;

const Vision = styled.div`
  font-size: 24px;
  line-height: 1.5;
  color: #333;
  margin-bottom: 30px;
`;

const Paragraph = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: #444;
  margin-bottom: 20px;
`;

const Title = styled.h1`
  font-size: 28px;
  color: #333;
  margin-bottom: 20px;
`;

const LocationInfo = styled.div`
  font-size: 16px;
  line-height: 1.6;
  color: #444;
  border-top: 1px solid #eee;
  padding-top: 20px;
  margin-top: 20px;
`;

const LoginButton = styled.button`
  padding: 12px 24px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 20px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #45a049;
  }
`;

function AboutUs() {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/login');
  };

  return (
    <Container>
      <Content>
        <Title>About Us</Title>
        <Vision>
          We have a vision to optimize the value of the global built environment through continuous improvement...
        </Vision>
        
        <Paragraph>
          Inspired by Dr. Calvin Kam, international thought leader and industry ambassador 
          in evidence-based business decision-making, performance metrics, best practice 
          processes, sustainability, and appropriate technologies.
        </Paragraph>

        <Paragraph>
          The global practice now provides research, education programs, management 
          consulting, and guidance to several government organizations – roadmaps and 
          mentoring for large property developers and owners – and value-enhancing 
          support to facility design, construction, and management teams. The firm also 
          assesses effective use of technologies such as Building Information Modeling 
          (BIM) for projects, teams, organizations, and economies worldwide.
        </Paragraph>

        <LocationInfo>
          Our teams work seamlessly between corporate offices in Palo Alto, Hong Kong, 
          and Singapore, our newly-merged organization in Amsterdam, and teammates 
          distributed more generally in Asia, the Americas, and Europe. We espouse a 
          World Village approach in concept and in action.
        </LocationInfo>

        <LoginButton onClick={handleLoginClick}>
          Log In
        </LoginButton>
      </Content>

      <LogoContainer>
        <Logo src={logo} alt="Company Logo" />
      </LogoContainer>
    </Container>
  );
}

export default AboutUs;